function sortParamsByDisplayIndex(params) {
        if (!Array.isArray(params)) {
            throw new Error('Input must be an array');
        }
        return params.sort((a, b) => {
            let defIndex = 9999
            const indexA = a?.display_index !== null && a?.display_index !== undefined ? Number(a.display_index) : defIndex;
            const indexB = b?.display_index !== null && b?.display_index !== undefined ? Number(b.display_index) : defIndex;

            // First sort by display_index
            if (indexA !== indexB) {
                return indexA - indexB;
            }

            // If display_index is the same, sort alphabetically by label
            // Handle cases where label might be undefined or null
            const labelA = a?.label || '';
            const labelB = b?.label || '';
            return labelA.localeCompare(labelB);
        });
    }
    
    export function reorderFieldsOnlyByIndex(fields) {
        return sortParamsByDisplayIndex(fields)
    }

    export function sortParametersByGroupOrder(params, customAttributes) {
        if (!Array.isArray(params)) return params;
        
        const groupingAttr = Array.isArray(customAttributes)
            ? customAttributes.find(attr => attr.attribute_type === 'GROUPING_PREFERENCE' && attr.sub_type === 'FLEXICO')
            : null;
        
        let groupInfo = {};
        let parameterMapping = {};
        
        if (groupingAttr?.attribute) {
            try {
                const parsed = JSON.parse(groupingAttr.attribute);
                groupInfo = parsed.group_info || {};
                parameterMapping = parsed.parameter_mapping || {};
            } catch (e) {
                console.error('Failed to parse grouping attributes:', e);
            }
        }
        
        return params.sort((a, b) => {
            const getGroupOrder = (param) => {
                const fieldId = param.field_id;
                if (!fieldId) return 0;
                const groupId = parameterMapping[fieldId];
                return groupId ? (parseInt(groupInfo[groupId]?.group_order) || 0) : 0;
            };
            
            const orderA = getGroupOrder(a);
            const orderB = getGroupOrder(b);
            
            return orderA - orderB;
        });
    }